// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>14</span>&nbsp;&nbsp;Satisfy us with your loving-kindness in the morning,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;that we may rejoice and be glad all our days.<br> </p> </div></div>";
// Exports
module.exports = code;